export const REDEEM_CREATE_REQUEST = "REDEEM_CREATE_REQUEST"
export const REDEEM_DELETE_REQUEST = "REDEEM_DELETE_REQUEST"
export const REDEEM_UPDATE_REQUEST = "REDEEM_UPDATE_REQUEST"
export const REDEEM_ADMIN_UPDATE_REQUEST = "REDEEM_ADMIN_UPDATE_REQUEST"
export const REDEEM_DETAILS_REQUEST = "REDEEM_DETAILS_REQUEST"
export const GET_REDEEMS_REQUEST = "GET_REDEEMS_REQUEST"
export const GET_ADMIN_REDEEMS_REQUEST = "GET_ADMIN_REDEEMS_REQUEST"



